<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/no-dupe-keys -->
<template>
    <div>
        <span v-html="formattedTitle" />
    </div>
</template>

<script>
import applyOnlineService from '../../api/services/applyOnlineService'

export default {
    name: 'TitleContent',
    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            newTitle: this.title,
        }
    },
    computed: {
        formattedTitle() {
            this.emailChanged()
            return this.newTitle.replaceAll('{br}', '<br>')
        },
    },
    methods: {
        emailChanged() {
            applyOnlineService.getSpecificConfigLayoutAsync().then((result) => {
                this.newTitle = this.newTitle.replace(
                    '{contactLink}',
                    `<a href="mailto:${result.emailContact}">${this.content}</a>`,
                )
            })
        },
    },
}
</script>